// Mirrors vetvalue-api/src/Reports.Modules/DocumentExtraction/Api/DocumentExtractionLimits.cs
// (backend is authoritative) — change both sides in the same turn.
export const MAX_DOCUMENT_SIZE_BYTES = 100 * 1024 * 1024;

export const ACCEPTED_DOCUMENT_EXTENSIONS = [
    '.pdf',
    '.tif',
    '.tiff',
    '.jpg',
    '.jpeg',
    '.png',
];

export const DOCUMENT_EXTRACTION_DROPZONE_ACCEPT = {
    'application/pdf': ['.pdf'],
    'image/tiff': ['.tif', '.tiff'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
};

const hasAcceptedExtension = (fileName: string): boolean => {
    const lowerCaseName = fileName.toLowerCase();
    return ACCEPTED_DOCUMENT_EXTENSIONS.some((extension) =>
        lowerCaseName.endsWith(extension)
    );
};

export const validateDocumentForExtraction = (file: {
    name: string;
    size: number;
}): string | null => {
    if (file.size > MAX_DOCUMENT_SIZE_BYTES) {
        return 'File exceeds the 100 MB limit';
    }
    if (!hasAcceptedExtension(file.name)) {
        return 'Unsupported file format. Allowed: PDF, TIFF, JPG, PNG';
    }
    return null;
};
